import {createAction} from "@reduxjs/toolkit";
import * as types from "../constants/ActionTypes";

export const hideAppointmentCreationModal = createAction(types.HIDE_APPOINTMENT_CREATION_MODAL);
export const hideMessageAppointmentCreationModal = createAction(types.HIDE_MESSAGE_APPOINTMENT_CREATION_MODAL);
export const saveCallCenterAppointment = createAction(types.SAVE_CALL_CENTER_APPOINTMENT);
export const saveCallCenterMessageAppointment = createAction(types.SAVE_CALL_CENTER_MESSAGE_APPOINTMENT);
export const saveComment = createAction(types.SAVE_COMMENT);
export const saveDateAppointment = createAction(types.SAVE_DATE_APPOINTMENT);
export const saveCallCenterAppointmentSuccess = createAction(types.SAVE_CALL_CENTER_APPOINTMENT_SUCCESS);
export const saveCallCenterMessageAppointmentSuccess = createAction(types.SAVE_CALL_CENTER_MESSAGE_APPOINTMENT_SUCCESS);
export const saveCallCenterAppointmentFailure = createAction(types.SAVE_CALL_CENTER_APPOINTMENT_FAILURE);
export const saveCallCenterMessageAppointmentFailure = createAction(types.SAVE_CALL_CENTER_MESSAGE_APPOINTMENT_FAILURE);
export const showAppointmentCreationModal = createAction(types.SHOW_APPOINTMENT_CREATION_MODAL);
export const showMessageAppointmentCreationModal = createAction(types.SHOW_MESSAGE_APPOINTMENT_CREATION_MODAL);



// WEBPACK FOOTER //
// ./src/actions/createAppointmentActions.js